import { SapError } from './sap-error';

export interface ISapErrorResponse {
  error?: {
    innererror: {
      errordetails: Array<{
        code: string;
        message: string;
      }>;
    };
    message: {
      lang: string;
      value: string;
    };
    code: string;
  };
}

/**
 * Function that takes an object and tries to parse the SapError within.
 *
 * @example
 * catchError((err) => {
 *   const sapError = parseSapError(err.error);
 *
 *   return throwError(() => sapError);
 * });
 *
 * @param error an error from SAP, usually from the error property on an HttpErrorResponse
 */
/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */
export const parseSapError = (
  error: ISapErrorResponse | null | undefined,
  httpStatusCode?: number
): SapError => {
  if (error?.error) {
    let code: string;
    let message: string;

    try {
      code = error.error.innererror.errordetails[0].code;
      message = error.error.innererror.errordetails[0].message;
    } catch {
      code = error.error.code;
      message = error.error.message.value;
    }

    message = `${message}§§§${JSON.stringify(error, undefined, 2)}`;

    return new SapError(message, code, httpStatusCode);
  }

  return new SapError(
    `Your lookup failed due to a SAP connectivity problem
Please verify the following:
\t•You have an active internet connection
\t•You are connected to the LEGO network (directly/VPN)
\t•You have an active user in SAP
§§§${JSON.stringify(error, undefined, 2)}`,
    undefined,
    httpStatusCode
  );
};
/* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */
